var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimesLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8164 8.625L17.6992 3.74219C18.334 3.15625 18.334 2.17969 17.6992 1.59375L16.625 0.519531C16.0391 -0.115234 15.0625 -0.115234 14.4766 0.519531L9.59375 5.40234L4.66211 0.519531C4.07617 -0.115234 3.09961 -0.115234 2.51367 0.519531L1.43945 1.59375C0.804688 2.17969 0.804688 3.15625 1.43945 3.74219L6.32227 8.625L1.43945 13.5566C0.804688 14.1426 0.804688 15.1191 1.43945 15.7051L2.51367 16.7793C3.09961 17.4141 4.07617 17.4141 4.66211 16.7793L9.59375 11.8965L14.4766 16.7793C15.0625 17.4141 16.0391 17.4141 16.625 16.7793L17.6992 15.7051C18.334 15.1191 18.334 14.1426 17.6992 13.5566L12.8164 8.625Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesLogoWhite);
export default __webpack_public_path__ + "static/media/timesLogoWhite.4ba70cee.svg";
export { ForwardRef as ReactComponent };